import React from 'react';
import styled from 'styled-components';
import shopService from 'modules/shop/services';
import useCashierCategory from '../hooks/useCategory';
import { Colors, Text } from '@fozito/common-ui';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  margin-top: 0px;
  margin-bottom: 10px;
  margin-right: 8px;
  padding: 0px 10px;
`;

const CategoryButton = styled.button<{ $active: boolean }>`
  padding: 12px;
  border: 1px solid ${Colors.neutral.border[2]};
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 48px;
  box-shadow: 0px 4px 8px -3px #2d23424d,
    0px 2px 4px 0px #2c234266;

  background: ${(props) =>
    props.$active ? Colors.secondary[3] : Colors.neutral.bg[1]};
  color: ${(props) =>
    props.$active ? Colors.neutral.text[1] : Colors.neutral.text[5]};
  &:hover {
   opacity: 0.8;
   background: #eee;
  }
  &:hover,
  &:active {
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.1s;
  }
  &.active {
    .title_h9_18_semibold_caplock {
      color: #fff;
    }

    &:hover {
      opacity: 0.8;
      background: ${Colors.secondary[3]};
    }
  }

`;

const CategoriesList = () => {
  const categories = shopService.selectors.categories();
  const [active, setActive] = useCashierCategory();

  return (
    <Container>
      {categories.map((category) => (
        <CategoryButton
          key={category.id}
          type='button'
          $active={active === category.id}
          className={active === category.id ? 'active' : ''}
          onClick={() => setActive(category.id)}
        >
          <Text title_h9_18_semibold_caplock>{category.categoryName}</Text>
        </CategoryButton>
      ))}
    </Container>
  );
};

export default CategoriesList;
